import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToggleSwitchCardComponent } from 'app/components/distinct-components/cards/toggle-switch-card/toggle-switch-card.component';
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';
import { SecondaryBtnComponent } from 'app/components/ui-kit/buttons/secondary-btn/secondary-btn.component';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { PageOverlayComponent } from 'app/components/ui-kit/page-components/page-overlay/page-overlay.component';
import { AppStateService } from 'app/services/app-state.service';
import { FlightOptionService } from 'app/services/flight-option-service';
import { FlightWatcherService } from 'app/services/flight-watcher-service';
import { TimeAndDateService } from 'app/services/time-and-date-service';
import { IconPromptCardComponent } from "../../../../../components/distinct-components/cards/icon-prompt-card/icon-prompt-card.component";
import { Router } from '@angular/router';
import { ConversationService } from 'app/services/conversation.service';
import { AlertMessageComponent } from 'app/components/ui-kit/alerts/alert-message/alert-message.component';

@Component({
  selector: 'app-agent-setup-watcher',
  standalone: true,
  imports: [CommonModule, PageOverlayComponent, ToggleSwitchCardComponent, SvgLoaderComponent, PrimaryBtnComponent, SecondaryBtnComponent, IconPromptCardComponent, AlertMessageComponent],
  templateUrl: './agent-setup-watcher.component.html',
  styleUrl: './agent-setup-watcher.component.scss'
})
export class AgentSetupWatcherComponent {
  @Input() flightData: any;
  @Output() onClose = new EventEmitter<boolean>();
  watcherData: any;
  isFlightOption: boolean = false;
  isPublic: boolean = true;
  watcherEnabled: boolean = false;
  isLoading = true;
  error: string = null;
  isAssigning = false;
  isUpdatingConversation = false;

  constructor(
    private flightOptionService: FlightOptionService,
    public appState: AppStateService,
    private timeAndDate: TimeAndDateService,
    private flightWatcherService: FlightWatcherService,
    private router: Router,
    private conversationService: ConversationService,
  ) { }


  ngOnInit() {
    if (!this.isFlightOption) {
      this.handleFlightData();
    } else {
      this.isLoading = false;
    }
  }

  async handleFlightData() {
    const user = this.appState.user.profile();
    const metaData = {
      isActive: true,
      isVisible: false,
      creatorId: user.id,
      isCreatorVerified: user.memberships?.some((m) => m.statementVerified) ?? false,
      creatorDisplayName: user.displayName,
      creatorLinkedInMatrix: [],
      memberships: user.memberships,
      createdAt: new Date(),
      updatedAt: new Date()
    };
    const transformedData = await this.flightOptionService.flattenDataModel(this.flightData, metaData);
    this.watcherData = transformedData;
    this.isLoading = false;
  }

  l(location) {
    return location.endsWith(', US') ? location.replace(/, US$/, '') : location;
  }

  d(date): string {
    return this.timeAndDate.formatDateToMMDDYY(date);
  }

  t(time): string {
    return this.timeAndDate.formatTimeForTimezone(this.watcherData.timezone, time);
  }

  async onClickAssignToAgent() {
    this.isAssigning = true;
    this.error = null;
    let newFlightOption: any = null;
    try {

      newFlightOption = await this.flightOptionService.createFlightOption(this.flightData, { isVisible: this.isPublic });

      this.flightData.id = newFlightOption.id;
      const watcherData = await this.flightWatcherService.createFlightWatcher(newFlightOption);
      if (watcherData.saved) {
        this.watcherEnabled = true;
      } else {
        if (newFlightOption?.id) {
          await this.flightOptionService.deleteFlightOption(newFlightOption.id).catch(cleanupErr => {
            console.error('Failed to clean up duplicate flight option:', cleanupErr);
          });
          this.flightData.id = null;
        }
        console.error(watcherData.reason);
        this.error = watcherData.reason;
      }
    } catch (err) {
      if (newFlightOption?.id) {
        await this.flightOptionService.deleteFlightOption(newFlightOption.id).catch(cleanupErr => {
          console.error('Failed to clean up flight option after watcher error:', cleanupErr);
        });
        this.flightData.id = null;
      }
      console.error(err);
      this.error = "Something went wrong.  Try again."
    } finally {
      this.isAssigning = false;
    }
  }

  onClickCancel(): void {
    if (this.watcherEnabled) {
      this.isUpdatingConversation = true;
      this.closeCurrentConvo(false);
      return;
    }
    this.onClose.emit();
  }

  onClickDone(): void {
    this.isUpdatingConversation = true;
    this.closeCurrentConvo(true);
  }

  async closeCurrentConvo(route: boolean): Promise<void> {
    const conversationId = this.appState.user.profile().currentConversationId;

    try {
      await this.conversationService.updateConversation(conversationId, { status: 'inactive' });

      if (route) {
        this.router.navigate(['/watchers']);
        this.appState.resetAgentState();
      } else {
        this.onClose.emit();
      }
    } catch (err) {
      console.error('Failed to update conversation:', err);
    } finally {
      this.isUpdatingConversation = false;
    }
  }


  onToggleIsPublic() {
    this.isPublic = !this.isPublic;
  }

}
